/**
 * The sales territory a customer is assigned in Edit Customer is stored as
 * `customer.region`. The API also returns a legacy `customerSalesRegion`
 * string (from `customer.salesRegion`), which nothing writes any more, so it
 * must not be shown as the territory.
 */
export const customerSalesTerritory = (
  site: any,
  regionTypesMirror: { [code: string]: string },
  fallbackRegion?: number
) => regionTypesMirror?.[site?.customerRegion || fallbackRegion];
